import { Injectable } from '@angular/core';
import { EmailItem } from '../interfaces/email-item.interface';
import { LogoutSubscriber } from 'shared/services/subscribers/logout-subscriber.service';
import { bcEnums } from 'common/common/constants/boldchat-enums';

@Injectable()
export class EmailList {
  private _emailWorkItemList: EmailItem[] = [];

  constructor(logoutSubscriber: LogoutSubscriber) {
    logoutSubscriber.subscribe(this.reset.bind(this));
  }

  public get emailWorkItemList() {
    return this._emailWorkItemList;
  }

  public getEmailWorkItemCount() {
    return this._emailWorkItemList.length;
  }

  private reset() {
    this._emailWorkItemList.length = 0;
  }

  public resetEmails() {
    this._emailWorkItemList = [];
  }

  public emailComparator(email1, email2) {
    if (this.isBothInbound(email1, email2) || this.isNoneInbound(email1, email2)) {
      return this.compareEmailByAssigned(email1, email2);
    }
    return (this.isInboundEmail(email1) ? -1 : 1);
  }

  compareEmailByAssigned(email1, email2) {
    if (email1.Assigned === email2.Assigned) {
      return 0;
    } else if (email1.Assigned < email2.Assigned) {
      return -1;
    }
    return 1;
  }

  isBothInbound(email1, email2) {
    return this.isInboundEmail(email1) && this.isInboundEmail(email2);
  }

  isNoneInbound(email1, email2) {
    return !this.isInboundEmail(email1) && !this.isInboundEmail(email2);
  }

  isInboundEmail(email) {
    return email.ActionType === bcEnums.emailActionTypes.EMAIL_TYPE_INBOUND;
  }
}
